export default __webpack_public_path__ + "b1d7889eb8cc01cc607c7e6dda1477b8.webp";